import React from 'react';
import classNames from 'classnames';
import styles from './sections.module.scss';

const ContactSection = ({ colors, contact, mobileLayout = false }) => (
  <section id="get-in-touch" className={classNames(styles.contact, mobileLayout && styles.contactMobile)}>
    <div className={styles.container}>
      <div className={styles.contactGrid}>
        <div className={styles.contactInfo}>
          <p className={styles.sectionLabel} style={{ color: colors.accent }}>
            GET IN TOUCH
          </p>
          <h2 className={styles.sectionHeading} style={{ color: colors.third }}>
            Got Questions?
            <br />
            We&apos;d Love to Hear From You
          </h2>
          <div className={styles.contactDivider} style={{ background: colors.accent }} />

          <div className={styles.contactDetails}>
            {contact.address && (
              <div className={styles.contactRow}>
                <div className={styles.contactIcon}>
                  <img src="/static/icons/webpage/asb-address-icon.png" alt="Address" />
                </div>
                <div>
                  <p className={styles.contactLabel}>ADDRESS</p>
                  <p className={styles.contactValue}>{contact.address}</p>
                </div>
              </div>
            )}
            {contact.phone && (
              <div className={styles.contactRow}>
                <div className={styles.contactIcon}>
                  <img src="/static/icons/webpage/asb-phone-icon.png" alt="Phone" />
                </div>
                <div>
                  <p className={styles.contactLabel}>PHONE</p>
                  <p className={styles.contactValue}>{contact.phone}</p>
                </div>
              </div>
            )}
            {contact.email && (
              <div className={styles.contactRow}>
                <div className={styles.contactIcon}>
                  <img src="/static/icons/webpage/asb-email-icon.png" alt="Email" />
                </div>
                <div>
                  <p className={styles.contactLabel}>EMAIL</p>
                  <p className={styles.contactValue}>{contact.email}</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className={styles.teamPhotoWrapper}>
          <img src="/static/img/webpage/business-team-photo.png" alt="Team" className={styles.teamPhoto} />
        </div>
      </div>
    </div>
  </section>
);

export default ContactSection;
